import styled from 'styled-components'

export const AboutContainer = styled.div`
  max-width: 850px;
  margin: 40px auto;
  font-family: 'Montserrat', sans-serif;
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  .hero-section {
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    padding: 48px 32px;
    text-align: center;
    border-bottom: 1px solid #bae6fd;

    .back-button {
      position: absolute;
      top: 24px;
      left: 24px;
      display: flex;
      align-items: center;
      gap: 8px;
      background: transparent;
      color: #94a3b8;
      border: none;
      font-family: inherit;
      font-size: 1rem;
      font-weight: 600;
      cursor: pointer;
      padding: 8px 12px;
      border-radius: 8px;
      transition: all 0.2s ease;

      &:hover {
        color: #ffffff;
        background-color: rgba(255, 255, 255, 0.1);
      }
    }

    .hero-gif {
      width: 100px;
      height: 100px;
      margin-bottom: 16px;
      animation: float 3s ease-in-out infinite;
    }

    h1 {
      font-size: 2.2rem;
      color: #0f172a;
      margin-bottom: 16px;
      font-weight: 800;
    }

    .hero-description {
      font-size: 1.1rem;
      color: #475569;
      max-width: 600px;
      margin: 0 auto 24px auto;
      line-height: 1.6;
    }

    .current-version-badge {
      display: inline-flex;
      align-items: center;
      gap: 12px;
      background: #ffffff;
      padding: 8px 20px;
      border-radius: 99px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
      border: 1px solid #e2e8f0;

      .label {
        font-weight: 600;
        color: #64748b;
        font-size: 0.95rem;
      }

      .version {
        background: #10b981;
        color: white;
        padding: 4px 12px;
        border-radius: 99px;
        font-weight: 700;
        letter-spacing: 0.5px;
      }

      .date {
        color: #94a3b8;
        font-size: 0.9rem;
      }
    }
  }

  .changelog-section {
    padding: 40px 48px;

    h2 {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 1.6rem;
      color: #1e293b;
      margin-bottom: 32px;

      .icon-blue {
        color: #3b82f6;
      }
    }
  }

  .timeline {
    position: relative;
    padding-left: 24px;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 3px;
      background: #e2e8f0;
      border-radius: 3px;
    }
  }

  .timeline-item {
    position: relative;
    margin-bottom: 32px;

    &:last-child {
      margin-bottom: 0;
    }

    .timeline-dot {
      position: absolute;
      left: -30.5px;
      top: 4px;
      width: 16px;
      height: 16px;
      background-color: #cbd5e1;
      border: 3px solid #ffffff;
      border-radius: 50%;
      box-shadow: 0 0 0 2px #e2e8f0;
      z-index: 1;
      transition: all 0.3s ease;
    }

    &.latest .timeline-dot {
      background-color: #3b82f6;
      box-shadow: 0 0 0 4px #bfdbfe;
    }

    .timeline-content {
      background: #f8fafc;
      border: 1px solid #f1f5f9;
      border-radius: 12px;
      padding: 24px;
      transition:
        transform 0.2s ease,
        box-shadow 0.2s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
        border-color: #e2e8f0;
      }
    }

    .version-header {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;
      margin-bottom: 16px;
      padding-bottom: 12px;
      border-bottom: 1px dashed #cbd5e1;

      .version-tag {
        background: #1e293b;
        color: #f8fafc;
        padding: 4px 10px;
        border-radius: 6px;
        font-family: 'Courier New', monospace;
        font-weight: 700;
        font-size: 1rem;
      }

      .version-date {
        color: #64748b;
        font-weight: 500;
        font-size: 0.95rem;
      }

      .new-badge {
        background: #ef4444;
        color: white;
        font-size: 0.75rem;
        font-weight: 800;
        padding: 2px 8px;
        border-radius: 99px;
        letter-spacing: 1px;
      }
    }

    .changes-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        margin-bottom: 12px;
        color: #475569;
        font-size: 0.95rem;
        line-height: 1.5;

        &:last-child {
          margin-bottom: 0;
        }

        .check-icon {
          color: #10b981;
          margin-top: 3px;
          flex-shrink: 0;
        }
      }
    }
  }

  .history-toggle-container {
    margin-top: 32px;
    margin-bottom: 32px;
    display: flex;
    justify-content: center;
  }

  .history-toggle-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 24px;
    border-radius: 99px;
    background: #f1f5f9;
    border: 1px solid #cbd5e1;
    color: #334155;
    font-size: 0.95rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: inherit;

    &:hover {
      background: #002b80;
      color: #ffffff;
      border-color: #002b80;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 43, 128, 0.2);
    }

    .count-badge {
      background: rgba(0, 0, 0, 0.08);
      padding: 2px 8px;
      border-radius: 12px;
      font-size: 0.8rem;
    }
  }

  @keyframes float {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
    100% {
      transform: translateY(0px);
    }
  }

  @media (max-width: 768px) {
    margin: 20px;

    .hero-section {
      padding: 32px 20px;
      h1 {
        font-size: 1.8rem;
      }
    }

    .changelog-section {
      padding: 32px 20px;
    }

    .timeline-content {
      padding: 16px;
    }
  }
`
